
export function replaceBaseUrl(baseUrl: string, uri: string): string {
  const queryParameter = uri.substring(
    uri.indexOf('?') + 1,
  )
  return `${baseUrl}?${queryParameter}`
}
